import { render, staticRenderFns } from "./AboutRoom.vue?vue&type=template&id=b01e5ef8&scoped=true"
import script from "./AboutRoom.vue?vue&type=script&lang=js"
export * from "./AboutRoom.vue?vue&type=script&lang=js"
import style0 from "./AboutRoom.vue?vue&type=style&index=0&id=b01e5ef8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b01e5ef8",
  null
  
)

export default component.exports